/* eslint-disable max-len */

export const environment = {
  production: true,
  debug: false,
  name: 'prod',
  captchKey: '6Le2iGkUAAAAAKtPwG6Lif-10ZJs3kFNsVr8Ob4L',
  disable3rdPartyModule: false,
  disableBoardModule: false,
  disableTrainingCtr: false,
  queryListLimit: 1000,
  region: 'us-east-1',
  // AI Chat foundation feature flag (default OFF; UI unchanged while false)
  aiChatEnabled: true,
  // Artifact Expert agent (document analysis from the Artifact Registry).
  // Default OFF: the button and the agent are hidden while false.
  artifactExpertEnabled: false,
};
